import { render, staticRenderFns } from "./PostalNode.vue?vue&type=template&id=0d225d4c"
import script from "./PostalNode.vue?vue&type=script&lang=js"
export * from "./PostalNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports